import React, { Component } from 'react'
import ConfiguratorSection from './../ConfiguratorSection'
import ConfiguratorImage from './../ConfiguratorImage'
import ConfiguratorOption from './../ConfiguratorOption'
import Dropdown from './../Dropdown'
import check from '../assets/check.png'
import Prompt from '../Prompt'
import Disclaimer from '../Disclaimer'
import { parse } from 'query-string'
import { NavLink } from 'react-router-dom'
import TransomConfigurator from './../TransomConfigurator'
import { withTranslation, Trans } from 'react-i18next'
import { exteriorView01ImageOptions } from './views/ExteriorView01'

class Xr41Hull extends Component {
  constructor (props) {
    super(props)

    this.state = {
      expanded: false,
      code: '',
      promptVisible: false,
      codeBoat: '',
      codePrompVisible: false,
      overlayUrls: []
    }

    this.handleHullColorChange = this.handleHullColorChange.bind(this)
    this.handleCodeSubmit = this.handleCodeSubmit.bind(this)
    this.handleOverlayUrls = this.handleOverlayUrls.bind(this)
  }

  componentDidMount () {
    const query = parse(this.props.location.search, { ignoreQueryPrefix: true })
    if (query.code !== undefined) {
      this.props.onCodeSubmitted(query.code)
    }
  }

  componentWillUnmount () {
    clearTimeout(this.timer)
  }

  handleHullColorChange (newValue) {
    let configuration = this.props.configuration
    configuration.HullColorways = newValue

    if (this.props.onChange) {
      this.props.onChange(configuration)
    }
  }

  handleOverlayUrls (urls) {
    const current = this.state.overlayUrls
    if (
      urls.length !== current.length ||
      urls.some((u, i) => u !== current[i])
    ) {
      this.setState({ overlayUrls: urls })
    }
  }

  handleCodeSubmit () {
    let json = JSON.parse(atob(this.state.code))

    if (json[0] !== 'Xr41') {
      if (typeof json[0] === 'string') {
        this.setState({
          codeBoat: json[0],
          codePrompVisible: true
        })
      }
      return
    }

    if (this.props.onCodeSubmitted) {
      this.props.onCodeSubmitted(this.state.code)
    }

    this.setState({ promptVisible: true })

    this.timer = setTimeout(() => {
      this.setState({ promptVisible: false })
    }, 5000)
  }

  render () {
    let imageOptions = exteriorView01ImageOptions
    let image = (
      <div style={{ position: 'relative' }}>
        <TransomConfigurator
          colorMultiplier={0.8}
          name={this.props.transom.Name}
          port={this.props.transom.Port}
          transomSize={{ width: 2222, height: 610 }}
          transform={[
            0.048182, -0.003583, 0, -3.8e-5, 0.006841, 0.090087, 0, 1.7e-5, 0,
            0, 1, 0, 158.701153, 368.419296, 0, 1
          ]}
        >
          <ConfiguratorImage
            boat='Xr41'
            configuration={this.props.configuration}
            options={imageOptions}
            onOverlayUrls={this.handleOverlayUrls}
          />
        </TransomConfigurator>

        {/* v1.05: Overlay images on top of everything including transom text */}
        {this.state.overlayUrls.length > 0 && (
          <div
            className='overlay-stack'
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              pointerEvents: 'none',
              zIndex: 10
            }}
          >
            {this.state.overlayUrls.map((url, idx) => (
              <img
                key={url}
                src={url}
                alt=''
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  objectFit: 'contain'
                }}
              />
            ))}
          </div>
        )}
      </div>
    )

    const hullColourOptions = this.props.hullColourOptions || []
    const showHullColourAsText = hullColourOptions.length === 1
    const selectedHullColour =
      this.props.configuration.HullColorways || hullColourOptions[0]

    return (
      <ConfiguratorSection image={image}>
        <ConfiguratorOption style={{ position: 'relative' }}>
          <Prompt type='info' visible={this.state.promptVisible}>
            <Trans defaults='Info prompt: Configuration loaded' />
          </Prompt>
          <Prompt type='error' visible={this.state.codePrompVisible}>
            <Trans
              defaults='Error prompt: Code is for {{boat}}'
              values={{ boat: this.state.codeBoat }}
            />{' '}
            <NavLink
              to={'/' + this.state.codeBoat + '?code=' + this.state.code}
            >
              <Trans defaults='Error prompt: go there' />
            </NavLink>
          </Prompt>

          <h1>
            <Trans defaults='Hull' />
          </h1>

          {showHullColourAsText ? (
            <p
              style={{
                maxWidth: 472,
                marginBottom: 20,
                padding: '10px 14px',
                border: '1px solid #d9d9d9',
                background: '#f7f7f7',
                borderRadius: 2
              }}
            >
              <strong>
                {selectedHullColour && selectedHullColour.label
                  ? selectedHullColour.label
                  : '-'}
              </strong>
              {selectedHullColour && selectedHullColour.description ? (
                <span> - {selectedHullColour.description}</span>
              ) : null}
            </p>
          ) : (
            <Dropdown
              options={hullColourOptions}
              onChange={this.handleHullColorChange}
              value={this.props.configuration.HullColorways}
              style={{ maxWidth: 472 }}
            />
          )}

          <p>
            <img
              style={{ border: '1px solid #c2c2c2' }}
              src={this.props.configuration.HullColorways.preview}
              alt={this.props.configuration.HullColorways.label}
            />
          </p>

          <h2>
            <Trans defaults='Hull' />
          </h2>
          <p>
            <Trans defaults='The XR 41 hull is supplied in white, with black stripes. Vinyl wrapping is available as an optional upgrade. Please contact your local dealer for further details.' />
          </p>
          <p>
            <Trans defaults='X-Yachts hulls are built using the latest high-tech construction technologies with a vacuum-infused, post-cured (oven baked @ 80 C) EPOXY construction and gelcoat finish.' />
          </p>
          <h2>
            <Trans defaults='Keel structure' />
          </h2>
          <p>
            <Trans defaults='Heat-galvanized steel keel frame improves strength, enables central lift hoist attachment and safety.' />
          </p>
          <h2>
            <Trans defaults='Load previous configuration' />
          </h2>

          <button
            className='button'
            style={{ marginRight: 15 }}
            onClick={() => {
              this.setState({ expanded: !this.state.expanded })
            }}
          >
            <Trans defaults='Load code' />
          </button>
          <div
            className={'expander' + (this.state.expanded ? ' open' : ' closed')}
          >
            <p>
              <input
                type='text'
                value={this.state.code}
                style={{ width: 262, verticalAlign: 'top', marginRight: 10 }}
                onChange={event => {
                  this.setState({ code: event.target.value })
                }}
              />
              <button
                className='secondary button'
                onClick={this.handleCodeSubmit}
              >
                <img src={check} alt='submit' />
              </button>
            </p>
          </div>
          <Disclaimer />
        </ConfiguratorOption>
      </ConfiguratorSection>
    )
  }
}

export default withTranslation()(Xr41Hull)



// WEBPACK FOOTER //
// ./src/Xr41/Xr41Hull.js